"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomeFastStart = exports.createSomePlaybackTime = exports.createSomeDisplaySizeItem = exports.createSomeAspectRatioItem = exports.createSomeAspectRatio = exports.createSomeAttribute = exports.createSomeCreativeType = exports.createSomePlacement = exports.createSomeNetwork = exports.createSomeCreativeFormat = void 0;
const CreativeFormat_1 = require("../entity/CreativeFormat");
const PricingPoint_1 = require("../entity/PricingPoint");
const pricingMerchandiseOption_1 = require("./pricingMerchandiseOption");
const pricingPoint_1 = require("./pricingPoint");
const requiredOption_1 = require("./requiredOption");
const createSomeCreativeFormat = ({ id = '4', resizeBaseId = '1', network = exports.createSomeNetwork(), placement = exports.createSomePlacement(), creativeType = exports.createSomeCreativeType(), attribute = exports.createSomeAttribute(), selectedPricingMerchandiseOptions = [
    pricingMerchandiseOption_1.createSomePricingMerchandiseOption({
        id: '123',
        name: 'Some Option 01',
        displayToOptimizer: true,
    }),
    pricingMerchandiseOption_1.createSomePricingMerchandiseOption({
        id: '456',
        name: 'Some Option 02',
        displayToOptimizer: true,
    }),
], } = {}) => new CreativeFormat_1.default({
    id,
    resizeBaseId,
    network,
    placement,
    creativeType,
    attribute,
    selectedPricingMerchandiseOptions,
});
exports.createSomeCreativeFormat = createSomeCreativeFormat;
const createSomeNetwork = ({ id = '5', key = 'facebook', name = 'Facebook', } = {}) => new CreativeFormat_1.CreativeFormatNetwork({ id, key, name });
exports.createSomeNetwork = createSomeNetwork;
const createSomePlacement = ({ id = '6', key = 'facebook_feeds', name = 'Facebook Feeds', } = {}) => new CreativeFormat_1.CreativeFormatPlacement({ id, key, name });
exports.createSomePlacement = createSomePlacement;
const createSomeCreativeType = ({ id = '7', key = 'video', name = 'Video', requiredPoints = PricingPoint_1.PricingPointKey.map(key => pricingPoint_1.createSomePricingPoint({ key })), } = {}) => new CreativeFormat_1.CreativeFormatCreativeType({ id, key, name, requiredPoints });
exports.createSomeCreativeType = createSomeCreativeType;
const createSomeAttribute = ({ aspectRatio = exports.createSomeAspectRatio(), playbackTime = exports.createSomePlaybackTime(), fastStart = exports.createSomeFastStart(), } = {}) => new CreativeFormat_1.CreativeFormatAttribute({ aspectRatio, playbackTime, fastStart });
exports.createSomeAttribute = createSomeAttribute;
const createSomeAspectRatio = ({ supportingAspectRatioId = '8', requiredOption = requiredOption_1.createSomeRequiredOption(), aspectRatio = exports.createSomeAspectRatioItem(), size = exports.createSomeDisplaySizeItem(), } = {}) => new CreativeFormat_1.CreativeFormatAspectRatio({ supportingAspectRatioId, requiredOption, aspectRatio, size });
exports.createSomeAspectRatio = createSomeAspectRatio;
const createSomeAspectRatioItem = ({ width = 1920, height = 1080, } = {}) => new CreativeFormat_1.AspectRatio({ width, height });
exports.createSomeAspectRatioItem = createSomeAspectRatioItem;
const createSomeDisplaySizeItem = ({ width = 1920, height = 1080, } = {}) => new CreativeFormat_1.DisplaySize({ width, height });
exports.createSomeDisplaySizeItem = createSomeDisplaySizeItem;
const createSomePlaybackTime = ({ supportingPlaybackTimeId = '9', requiredOption = requiredOption_1.createSomeRequiredOption(), seconds = 15, } = {}) => new CreativeFormat_1.CreativeFormatPlaybackTime({ supportingPlaybackTimeId, requiredOption, seconds });
exports.createSomePlaybackTime = createSomePlaybackTime;
const createSomeFastStart = ({ enabled = true, } = {}) => new CreativeFormat_1.CreativeFormatFastStart({ enabled });
exports.createSomeFastStart = createSomeFastStart;
